export async function postData (url: string, data: object = {}): Promise<any> {
    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        cache: 'no-cache',
        body: JSON.stringify(data)
    });
    const { response: body } = await res.json();

    if (!res.ok) {
        throw new Error(`request failed: got response code ${res.status}`);
    }

    return body;
}
